module.exports = __webpack_public_path__ + "img/Wizard.baa396d1.png";